<template>
	<div class="block-white-rounded d-flex flex-column gap-3">
		<h2 class="h5 mb-0">{{ pll["With a salary of"] }}</h2>
		<div class="d-flex flex-column flex-md-row md-align-items-center gap-3">
			<div class="d-flex flex-column gap-2">
				<div class="">
					<input 
						data-name="salary"
						:data-value="salary"

						v-model="salary"
						type="text"
						maxlength="9"
						oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
						class="form-control min-w-275 analytics"
					/>
				</div>
			</div>
			<custom_select 
				data-name="currency"
				:data-value="currency"
				class="select__analytics"
				v-model="currency" :options="$store.state.currencies_list" @update:modelValue="update()" />
		</div>

		<span class="h6 mb-0">{{ pll["Per"] }}</span>
		<div class="ca-period">
			<button 
				data-name="period"
				data-value="hour"
				class="btn click__analytics" :class="{ active: perWhat == 'hour' }" type="button" @click="setPerWhat('hour')">{{ pll["Hour"] }}</button>
			<button
				data-name="period"
				data-value="month"
				class="btn ca-center-btn click__analytics" :class="{ active: perWhat == 'month' }" type="button" @click="setPerWhat('month')">{{ pll["Month"] }}</button>
			<button
				data-name="period"
				data-value="year"
				class="btn click__analytics" :class="{ active: perWhat == 'year' }" type="button" @click="setPerWhat('year')">{{ pll["Year"] }}</button>
		</div>

		<span class="h6 mb-0">{{ pll["Brutto / netto"] }}</span>
		<div class="ca-period">
			<button 
				data-name="type"
				data-value="brutto"
				class="btn click__analytics" type="button" :class="{ active: brutto }" @click="brutto = true">{{ pll["Brutto"] }}</button>
			<button 
				data-name="type"
				data-value="netto"
				class="btn click__analytics" type="button" :class="{ active: !brutto }" @click="brutto = false">{{ pll["Netto"] }}</button>
		</div>
		<small class="text-muted" v-if="brutto">
			{{ pll["Brutto – total compensation paid by employer, before taxes deducted"] }}
		</small> 
		<small class="text-muted" v-else>
			{{ pll["Netto – net salary after all taxes, so-called “on-hand”"] }}
		</small> 
	</div>

</template>
<script>
import title_value from "./title_value";
import custom_select from "./custom_select";

export default {
	components: {
		title_value,
		custom_select,
	},
	watch: {
		salary() {
			this.update();
		},
		perWhat() {
			this.update();
		},
		brutto: function () {
			this.$emit("brutto", this.brutto);
		},
	},
	props: {
		defaultCurrency: {
			required: false,
			default: "EUR"
		}
	},
	data() {
		return {
			salary: 0,
			perWhat: "hour",
			brutto: true,
			hour_on_day: 8,
			day_per_week: 5,
			weeks_in_month: 4.345,
			months_in_year: 12,
			currency: this.defaultCurrency
		};
	},
	methods: {
		setPerWhat(name) {
			this.perWhat = name;
		},

		update() {
			let salary_month = 0;
			switch (this.perWhat) {
				case 'hour':
					salary_month = this.salary * this.hour_on_day * this.day_per_week * this.weeks_in_month;
					break;
				case 'month':
					salary_month = this.salary;
					break;
				case 'year':
					salary_month = this.salary / this.months_in_year;
					break;
			}

			let value = salary_month / this.$store.state.currencies[this.currency];
			value = value * this.$store.state.currencies[this.$store.state.currency_for_calculate_taxes];
			this.$emit("update", value);
		}
	},
};
</script>
